<template>
  <div v-if="!singleLine" :class="{ columns: isHorizontal }">
    <div
      v-if="inclusions.length"
      :class="{ 'column is-6': isHorizontal }"
      :data-e2e="BillingCypressAttribute.views.INCLUSIONS"
    >
      <div v-if="showSubtitles" class="m-b-10 has-text-weight-semibold is-size-4">
        {{ $t(pluralize('billing.inclusion', inclusions.length)) }}:
      </div>
      <div
        v-for="(inclusion, index) in inclusions"
        :key="`inclusion-${index}`"
        class="m-b-10 is-flex"
      >
        <i :class="`icon cls cls-${inclusionIcon} m-r-2 is-size-6 m-t-1 has-text-primary`" />
        <slot name="inclusion-text" :inclusion="inclusion">
          <span>{{ inclusion }}</span>
        </slot>
      </div>
    </div>
    <div
      v-if="exclusions.length"
      :class="{ 'column is-6': isHorizontal }"
      :data-e2e="BillingCypressAttribute.views.EXCLUSIONS"
    >
      <div v-if="showSubtitles" class="m-b-10 has-text-weight-semibold is-size-4">
        {{ $t(pluralize('billing.exclusion', exclusions.length)) }}:
      </div>
      <div
        v-for="(exclusion, index) in exclusions"
        :key="`exclusion-${index}`"
        class="m-b-10 is-flex"
      >
        <i :class="`icon cls cls-${exclusionIcon} m-r-2 is-size-6 m-t-1 has-text-danger`" />
        <span>{{ exclusion }}</span>
      </div>
    </div>
  </div>
  <div v-else class="is-flex is-flex-wrap-wrap is-align-items-center">
    <div
      v-for="(inclusion, index) in inclusions"
      :key="`inclusion-${index}`"
      class="is-flex is-align-items-center m-r-10"
    >
      <i :class="`icon cls cls-${inclusionIcon} m-r-2 is-size-6 has-text-primary`" />
      <span>{{ inclusion }}</span>
    </div>
    <div
      v-for="(exclusion, index) in exclusions"
      :key="`exclusion-${index}`"
      class="is-flex is-align-items-center m-r-10"
    >
      <i :class="`icon cls cls-${exclusionIcon} m-r-2 is-size-6 has-text-danger`" />
      <span>{{ exclusion }}</span>
    </div>
  </div>
</template>
<script>
import { BillingCypressAttribute } from '@/modules/billing/constants/BillingCypressAttribute';
import pluralize from 'pluralize';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'BillingCardInclusionsExclusions',
  slotsDefinition: {
    inclusionText: { inclusion: String }
  },
  props: {
    inclusions: {
      type: Array,
      default: () => []
    },
    exclusions: {
      type: Array,
      default: () => []
    },
    showSubtitles: {
      type: Boolean,
      default: true
    },
    isHorizontal: {
      type: Boolean,
      default: true
    },
    inclusionIcon: {
      type: String,
      default: 'check'
    },
    exclusionIcon: {
      type: String,
      default: 'remove'
    },
    singleLine: {
      type: Boolean,
      default: false
    }
  },
  static: {
    BillingCypressAttribute
  },
  methods: { pluralize }
};
</script>
